// src/pages/wallet/walletCollection/tableColumns.js

const formatMoneyCOP = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "-";
  try {
    return n.toLocaleString("es-CO", {
      style: "currency",
      currency: "COP",
      maximumFractionDigits: 0,
    });
  } catch (_) {
    return `$ ${n.toLocaleString("es-CO")}`;
  }
};

export const walletCollectionColumns = [
  {
    field: "client_name",
    header: "Cliente",
    columnWidth: "500px",
  },
  {
    field: "invoice_number",
    header: "Nro de Factura",
    align: "center",
  },
  {
    field: "receipt",
    header: "N° de Recibo",
    align: "center",
    columnType: "custom",
    render: (row) => (
      <p className="table-default-column">
        {row.receipt != null && String(row.receipt).trim() !== "" ? row.receipt : "—"}
      </p>
    ),
  },
  {
    field: "business_line_name",
    header: "Línea de negocio",
    columnType: "custom",
    align: "center",
    render: (row) => (
      <p className="table-default-column">
        {row.business_line_name != null && String(row.business_line_name).trim() !== ""
          ? row.business_line_name
          : "—"}
      </p>
    ),
  },
  {
    field: "total_value",
    header: "Valor total venta",
    columnType: "custom",
    align: "right",
    render: (row) => (
      <p className="table-default-column">{formatMoneyCOP(row.total_value)}</p>
    ),
  },
  {
    field: "cartera_value",
    header: "Valor cartera",
    columnType: "custom",
    align: "right",
    render: (row) => (
      <p className="table-default-column">
        {row.cartera_value != null && Number(row.cartera_value) > 0
          ? formatMoneyCOP(row.cartera_value)
          : "—"}
      </p>
    ),
  },
  {
    field: "paid_value",
    header: "Valor pagado",
    columnType: "custom",
    align: "right",
    render: (row) => (
      <p className="table-default-column">{formatMoneyCOP(row.paid_value)}</p>
    ),
  },
  {
    field: "pending_value",
    header: "Saldo pendiente",
    columnType: "custom",
    align: "right",
    render: (row) => (
      <p className="table-default-column">
        {row.pending_value != null && row.pending_value !== undefined
          ? formatMoneyCOP(row.pending_value)
          : "—"}
      </p>
    ),
  },
  {
    field: "created_at",
    header: "Fecha creación",
    columnType: "custom",
    align: "center",
    render: (row) => (
      <p className="table-default-column">{(row.created_at)}</p>
    ),
  },
  {
    field: "paid_at",
    header: "Fecha pago",
    columnType: "custom",
    align: "center",
    render: (row) => (
      <p className="table-default-column">{(row.paid_at)}</p>
    ),
  },
  {
    field: "due_date",
    header: "Fecha vencimiento",
    columnType: "custom",
    align: "center",
    render: (row) => (
      <p className="table-default-column">{(row.due_date)}</p>
    ),
  },
  {
    field: "effective_collection_days",
    header: "Días efectivos de recaudo",
    columnType: "custom",
    align: "center",
    render: (row) => (
      <p className="table-default-column">
        {row.effective_collection_days !== null &&
        row.effective_collection_days !== undefined
          ? row.effective_collection_days
          : "-"}
      </p>
    ),
  },
  {
    field: "wallet_days",
    header: "Días cartera",
    columnType: "custom",
    align: "center",
    render: (row) => (
      <p className="table-default-column">
        {row.wallet_days !== null && row.wallet_days !== undefined
          ? row.wallet_days
          : "-"}
      </p>
    ),
  },
];
